<mat-toolbar class="p-0 mat-elevation-z1">
  <div class="flex-1 flex-row align-start-center">

    <div class="logo-group flex-noshrink flex-row align-start-center">
    @if (!hiddenNavbar) {
      <button mat-icon-button class="navbar-toggle-button toolbar-btn-fold"
        (click)="toggleSidebarFolded('navbar')">
        <mat-icon class="secondary-text">menu</mat-icon>
      </button>
      <button mat-icon-button class="navbar-toggle-button toolbar-btn-open"
        (click)="toggleSidebarOpen('navbar')">
        <mat-icon class="secondary-text">menu</mat-icon>
      </button>
    } @else {
      <button mat-icon-button class="navbar-toggle-button"
        (click)="goToHome()">
        <mat-icon class="secondary-text">arrow_back</mat-icon>
      </button>
    }



    @if (false && !hiddenNavbar && !rightNavbar) {
      <div class="toolbar-separator"></div>
    }

    @if (
      !customerGroupTemplate?.customPortalTemplate?.logoId &&
      !customerGroupHasTemplate &&
      !loadingCustomGroupTemplate) {
      <div class="logo">
        @if (customerGroupTemplate?.defaultBase64PortalLogo) {
          <img  style="max-height: 40px;max-width: 180px;" [src]="customerGroupTemplate.defaultBase64PortalLogo"
            >
        }
      </div>
    }
    @if (customerGroupTemplate?.customPortalTemplate?.logoId && customerGroupTemplate!.customPortalTemplate!.logoId! > 0 && !loadingCustomGroupTemplate) {
      <div class="logo">
        <img
          src="{{imageFileService.getPictureUrlFromImageFileTemplateId(customerGroupTemplate!.customPortalTemplate!.logoId!)}}"
          style="max-height: 64px"
          class="p-5 toolbar-custom-logo">
      </div>
    }

    @if (horizontalNavbar) {
      <div class="flex-row align-start-center">
        <div class="logo ml-16">
          <img class="logo-icon" src="assets/images/logos/fuse.svg">
        </div>
      </div>
    }

    <div class="px-8 px-md-16">
      @if (false) {
        <fuse-shortcuts [navigation]="navigation"></fuse-shortcuts>
      }
    </div>
    <div class="toolbar-separator"></div>
    <app-customer-group-tool-bar></app-customer-group-tool-bar>
    <div class="toolbar-separator"></div>

  </div>
  <div class="toolbar-search-center">
    <app-search></app-search>
  </div>

  <div class="flex-1 flex-row align-end-center">


    <!--<fuse-search-bar (input)="search($event)"></fuse-search-bar>-->



    @if (clientStatusEnabled) {
      <app-client-status-toolbar></app-client-status-toolbar>
    }

    @if (!isWindowsOS() && contingencyEnabled()) {
      <div>
        <div class="mr-8 s-16 flex-row"
          [matTooltip]="'Alguns recursos são limitados no Modo de Contingência.\n\nRecursos indisponíveis:\n• Impressora R2\n• Meus impressos\n• Meus arquivos\n• Meus uploads'"
          [style.cursor]="'pointer'"
          matTooltipClass="my-tooltip-multiline">
          <div class="contingence-mode-title">
            Modo Contingência
          </div>
        </div>
      </div>
    }

    <div class="toolbar-separator"></div>
    @if (!loadingCustomGroupTemplate) {
      <button mat-button aria-haspopup="true" class="language-button" (click)="helpLink()">
        <div class="mr-8 s-16 flex-row">
          <mat-icon aria-hidden="false" class="yellow-900-fg" aria-label="Ajuda">help</mat-icon>
          <div class="ml-8 toolbar-help-text" style="font-size: 16px;margin-top: 1px;">Ajuda</div>
        </div>
      </button>
    }
    <div class="toolbar-separator"></div>
    @if ((user$|async); as user) {
      <button mat-button [matMenuTriggerFor]="userMenu" (onMenuOpen)="onMenuOpen()"
        class="user-button" id="toolbar-menu-profile">
        <div class="flex-row align-center-center">
          @if (user;) {
            <img appImgFallback class="avatar mr-0 mr-sm-16"
              src="{{imageFileService.getManagerUserPicture(user.managerUser)}}?w=150&square=true">
          }
          @if (user && user.managerUser.displayName) {
            <span class="username mr-12 text-max-120 toolbar-username"
            >{{user.managerUser.displayName}}</span>
          } @else {
            <span class="username mr-12 text-max-120 toolbar-username">{{user.email}}</span>
          }
          <mat-icon class="s-16 toolbar-arrow-down">keyboard_arrow_down</mat-icon>
        </div>
      </button>
    }
    <div>
      <mat-menu #userMenu="matMenu" [overlapTrigger]="false">

        <button mat-menu-item routerLink="/profile" id="toolbar-menu-profile-edit">
          <mat-icon>account_circle</mat-icon>
          <span>Minha conta</span>
        </button>
        <button mat-menu-item class="" (click)="logout()" id="toolbar-menu-logout">
          <mat-icon>exit_to_app</mat-icon>
          <span>Logout</span>
        </button>
        <hr class="separator"/>
        <mat-slide-toggle class="m-20" (change)="toggleContingencyMode()" [formControl]="contingencyModeControl" >
          Modo contingência
        </mat-slide-toggle>
        <button mat-menu-item class="" (click)="closeClient()" id="toolbar-menu-logout" >
          <mat-icon>power_settings_new</mat-icon>
          <span>Close client</span>
        </button>
        <button mat-menu-item class="" (click)="statusClient()" id="toolbar-menu-logout">
          <mat-icon>info</mat-icon>
          <span>Status client</span>
        </button>
        <button mat-menu-item (click)="toggleDarkMode()">
          <mat-icon>{{isDarkMode ? 'brightness_7' : 'brightness_4'}}</mat-icon>
          <span>{{isDarkMode ? 'Modo Claro' : 'Modo Escuro'}}</span>
        </button>
        <button mat-menu-item (click)="clientDownload.download()">
          <mat-icon>cloud_download</mat-icon>
          <span>Agente</span>
        </button>
        <button mat-menu-item >
          <mat-icon>info_outline</mat-icon>
          <span>v {{clientVersion}}</span>
        </button>
      </mat-menu>
    </div>

    @if (false) {
      <button mat-button
        class="language-button"
        [matMenuTriggerFor]="languageMenu">
        <div class="flex-row align-center-center">
          <img class="flag mr-8" [src]="'assets/icons/flags/'+selectedLanguage.flag+'.png'">
          <span class="iso text-uppercase">{{selectedLanguage.id}}</span>
        </div>
      </button>
    }

    <mat-menu #languageMenu="matMenu" [overlapTrigger]="false">

      @for (lang of languages; track lang) {
        <button mat-menu-item (click)="setLanguage(lang)">
          <span class="flex-row align-start-center">
            <img class="flag mr-16" [src]="'assets/icons/flags/'+lang.flag+'.png'">
            <span class="iso">{{lang.title}}</span>
          </span>
        </button>
      }

    </mat-menu>

    @if (false) {
      <div class="toolbar-separator"></div>
    }

    @if (false) {
      <button mat-icon-button
        class="quick-panel-toggle-button"
        (click)="toggleSidebarOpen('quickPanel')"
        aria-label="Toggle quick panel">
        <mat-icon class="secondary-text">format_list_bulleted</mat-icon>
      </button>
    }

    @if (!hiddenNavbar && rightNavbar) {
      <div class="toolbar-separator toolbar-separator-right"></div>
    }

    @if (!hiddenNavbar && rightNavbar) {
      <button mat-icon-button class="navbar-toggle-button toolbar-right-navbar-toggle"
        (click)="toggleSidebarOpen('navbar')">
        <mat-icon class="secondary-text">menu</mat-icon>
      </button>
    }

  </div>

</div>

</mat-toolbar>
